import { styled } from "../stitches.config";

export const Main = styled('main', {
  width: 'calc(100% - var(--space-3) * 2)',
  maxWidth: '1228px',

  marginInline: 'auto',

  '@large': {
    width: 'calc(100% - var(--space-5) * 2)',
  }
})
